import ConsentComponent from "../components/ConsentComponent";

import useConsent from "../hook/useConsent";


const ConsentPage = ({

}) => {
    const consent = useConsent();
    return <ConsentComponent {...consent} />
}
export default ConsentPage;